<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
        <div class="row " style="padding: 15px;">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm" >
                <div class="sectionCenterTitle">
                    <h2 class="sectionTitle" i18n="@@company-news" style="color: rgb(59, 59, 59);">Şirket Haberleri
                    </h2>
                </div>
                <div class="row" *ngIf="lastNewsList?.length>0">
                    <div class="col-sm-12 col-md-12 col-lg-12 wow fadeIn" data-wow-delay="100ms">
                        <div class="blog-entry">
                            <div class="entry--img">
                                <a [routerLink]="['/company-news',lastNewsList[0]?.url]" title="{{lastNewsList[0]?.title}}">
                                    <img loading="lazy" src="{{domainURL}}halka-arz-haber.webp" alt="{{lastNewsList[0]?.title}}" title="{{lastNewsList[0]?.title}}" class="company-news-img">
                                    <div class="entry--overlay"></div>
                                </a>
                            </div>
                            <div class="entry--content">
                                <span class="entry--date">{{lastNewsList[0]?.createDate | date: 'EEEE, MMMM d,y'}}</span>
                                <div class="entry--title">
                                    <h4 class="company-new-title"><a [routerLink]="['/company-news',lastNewsList[0]?.url]"
                                        title="{{lastNewsList[0]?.title}}">{{lastNewsList[0]?.title}}</a></h4>
                                </div>
                                <div class="entry--bio">
                                    {{lastNewsList[0]?.subTitle}}
                                </div>
                                <div class="entry--footer">
                                    <div class="entry--more">
                                        <a  [routerLink]="['/company-news',lastNewsList[0]?.url]" title="Devamını Oku"> <fa-icon [icon]="faPlus" aria-hidden="true" class="header-icons"
                                            style="font-size: 17px;"></fa-icon>Devamını oku</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ng-template ngFor let-lastNews [ngForOf]="lastNewsList" let-i="index"
                        [ngForTrackBy]="trackByFnNews">
                        <div *ngIf="i>0" class="col-sm-12 col-md-6 col-lg-6 wow fadeIn" data-wow-delay="100ms">
                            <div class="blog-entry">
                                <div class="company-news-img">
                                    <a [routerLink]="['/company-news',lastNews?.url]" title="{{lastNews?.title}}">
                                        <img loading="lazy" loading="lazy" class="info-img"
                                            src="{{domainURL}}halka-arz-haber.webp" alt="{{lastNews?.title}}" title="{{lastNews?.title}}">
                                        <div class="entry--overlay"></div>
                                    </a>
                                </div>
                                <div class="entry--content">
                                    <span class="entry--date">{{lastNews.createDate | date: 'EEEE, MMMM d, y'}}</span>
                                    <div class="entry--title">
                                        <h4 class="company-new-title"><a [routerLink]="['/company-news',lastNews?.url]"
                                                title="{{lastNews?.title}}">{{lastNews?.title}}</a></h4>
                                    </div>
                                    <div class="entry--bio">
                                        {{lastNews?.subTitle}}
                                    </div>
                                    <div class="entry--footer">
                                        <div class="entry--more">
                                            <a  [routerLink]="['/company-news',lastNews?.url]"
                                                title="Devamını Oku"><fa-icon [icon]="faPlus"></fa-icon>Devamını oku</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-sm-12 col-md-12 col-lg-12 clearfix mt-10 text--center">
                        <app-mansel-pagination [pageIn]="page"
                            (setManselPaginePageEvent)="setPage($event)"></app-mansel-pagination>
                    </div>
                </div>
                <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px;">
                    <div class="row">
                     <div class="col-4"style="width:auto;height:auto;">
                        <picture>
                            <source media="(max-width: 90px)" srcset="{{domainURL}}halka-arz.webp" />
                            <source media="(min-width: 90px)" srcset="{{domainURL}}halka-arz.webp" />
                            <img loading="lazy" width="90px" height="60px" src="{{domainURL}}halka-arz.webp" alt="Şirket Haberleri" title="Şirket Haberleri">  
                        </picture></div>
                    <div class="col-8"><strong>Halka Arz Haberleri</strong>ve borsa haberlerini <a [routerLink]="'/news'"> Haberler</a> sayfamızdan okuyabilirsiniz.</div>
                    <div class="w-100"></div>
                    <br>
                    <p>Şirketlerin haberlerine <strong><a [routerLink]="'/company-news'">Şirket Haberleri </a></strong>sayfamızdan ulaşabilirsiniz.</p>
                    </div>
                </div>
                <br>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-draft-month [toYear]="toYear"></app-draft-month>
                <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                <app-summary-info></app-summary-info>
                <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
            </div>
            
        </div>
    </div>
</section>